/**
 * Input check for sysadmin-made redirects (spec §7.4). Mirrors the DB check
 * constraint and the webspace validation: lowercase letters, digits and
 * hyphens per segment, leading slash, no trailing slash. The account root "/"
 * is only allowed as a "from" path.
 */
const PATH = /^(\/[a-z0-9-]+)+$/;

// eslint-disable-next-line import/prefer-default-export
export function normalizeRedirectPath(input, { allowRoot }) {
  if (typeof input !== 'string') return null;
  const trimmed = input.trim().replace(/\/+$/, '');
  if (trimmed === '') return allowRoot ? '/' : null;
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return PATH.test(path) ? path : null;
}
